module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h1', [_vm._v("We are experiencing some problems.")]), _vm._v(" "), _c('p', [_vm._v("We are most likely already fixing the problem. If you keep seeing this message for more than one day, then please contact ERPLY support.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-a40b9fa4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Error/GeneralError.vue
// module id = 1703
// module chunks = 1